// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EOIX","colBig":"styles_colBig__2HdVB","colSmall":"styles_colSmall__1k6AB"};